import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Modal as RModal } from 'rsuite';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from "react-headless-accordion";
import Button from '../../common/Button';
import { setWarrantyDisclosureFiles } from '../../../reducers/filesReducer';
import { postRequest } from '../../../config';

const WarrantyDisclosureTargetList = ({ openRModal, setOpenRModal, reloadModule, setSection, section }) => {
    const [loading, setLoading] = useState(false)
    const { company, tab, rModalData } = useSelector((state) => state.fileAllocation)
    const { filesMoving } = useSelector((state) => state.files)
    const { selectedCompany } = useSelector(state => state.company)
    const [selectedQuestion, setSelectedQuestion] = useState(null)
    const Chevron = ({ className = "" }) => {
        return (
            <svg className={className} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd"></path></svg>
        )
    };
    const dispatch = useDispatch()

    const selectTargetSection = async (qNo) => {
        setSelectedQuestion(qNo)
        const data = {
            file: rModalData?.fileData,
            "unallocated": false,
            "companyId": selectedCompany['_id'],
            "isCut": rModalData.actionType === "move",
            "qNo": qNo,
            "tab": "warranty-disclosure",
            "oldQno": rModalData?.section?.questionId,
            "isDeduper": false,
            "key": rModalData?.key,
            "sectionName": rModalData?.section?.name
        }
        let selectedData = filesMoving && filesMoving.length ? filesMoving.filter((fileMove) => fileMove['oldQno'] !== rModalData?.section?.no) : []
        dispatch(setWarrantyDisclosureFiles([
            ...selectedData,
            data
        ]))
    };

    const handleClose = () => {
        setOpenRModal(false)
    }

    const handleConfirm = async () => {
        setLoading(true)
        try {
            let i = 0;
            while (i < filesMoving.length) {
                const selectedData = filesMoving[i]
                const res = await postRequest('/company/moveFile', selectedData);
                if (!res || res['code'] != 200) return;
                if (selectedData.isCut) {
                    setSection((prevSection) => {
                        if (!prevSection) return prevSection;

                        const updatedSection = JSON.parse(JSON.stringify(prevSection));

                        const questionIndex = updatedSection.questions.findIndex(
                            (q) => q.qNo === selectedData.oldQno
                        );
                        if (questionIndex === -1) return prevSection;

                        const originalFiles = updatedSection.questions[questionIndex].answer?.files || [];

                        const filteredFiles = originalFiles.filter(
                            (file) => file.key !== selectedData?.key
                        );

                        // Update in the questions array
                        updatedSection.questions[questionIndex].answer.files = filteredFiles;

                        // Also update in the standalone question object if it's the same qNo
                        if (updatedSection.question?.qNo === selectedData.oldQno) {
                            updatedSection.question.answer.files = filteredFiles;
                        }

                        console.log("*******", updatedSection, "**********");
                        return updatedSection;
                    });

                }
                i++;
            }
            setOpenRModal(false)
            reloadModule("warranty-disclosure", false, false, true)
            dispatch(setWarrantyDisclosureFiles([]))
        } catch (err) {
            console.log(err)
        } finally {
            setLoading(false)
        }
    }

    const getSectionDropDown = (section, fileKey, from, index) => {
        const qNo = section.sectionNo || section.no
        const name = section.sectionName || section.name; // Section name

        if (section.questions) {
            // Main section with dropdown (only for top-level sections)
            return (
                <AccordionItem key={qNo}>
                    {({ open }) => (
                        <div className={"lightBorder mb0-5rem w100 jcsb cp "}>
                            {/* Dropdown Header */}
                            <AccordionHeader
                                className="df aic jcsb bg1 w100 dropdown-section-header px2rem"
                            >
                                <h3 className="c15 fw400 tal">
                                    {qNo}. - {name}
                                </h3>
                                <Chevron
                                    className={`w2rem h2rem c3 td300 ml0-5rem ${!open ? "tr90deg" : "tr270deg"
                                        }`}
                                />
                            </AccordionHeader>

                            {/* Dropdown Body */}
                            <AccordionBody>
                                <div>
                                    {section.questions.map((question) => {
                                        const subFolder = {
                                            sectionNo: question?.qNo,
                                            sectionName: section?.name
                                        }
                                        return getSectionDropDown(
                                            subFolder,
                                            fileKey,
                                            from,
                                            index
                                        );
                                    })}
                                </div>
                            </AccordionBody>
                        </div>
                    )}
                </AccordionItem>
            );
        } else {
            return (
                <div
                    key={qNo}
                    className={`rs-dropdown-item ${(selectedQuestion && qNo === selectedQuestion) ? 'selected' : ''}`}
                    onClick={() => selectTargetSection(qNo)}
                >
                    {qNo}. {name}
                </div>
            );
        }
    };

    const getModuleDropdown = (module, key, from, index) => {
        if (module?.sections?.length == 1) {
            const singleSection = module?.sections[0];
            if (singleSection.subFolders) {
                return <>
                    {Object.values(singleSection.subFolders)
                        .map(section => {
                            return getSectionDropDown(section, key, from, index);
                        })
                    }
                </>
            }
        }

        return <>
            {module?.sections && Object.values(module?.sections).map(section => {
                return (
                    getSectionDropDown(section, key, from, index)
                )
            })}
        </>
    };

    return (
        <>
            <RModal overflow={true} open={openRModal} onClose={handleClose} style={{ zIndex: '2000' }}>
                <RModal.Header>
                    <div className='df aic jcfs'>
                        {
                            ["move", "reallocate"].includes(rModalData.actionType) ? <>
                                <img
                                    src={require("../../../../images/dataRepo/send.svg")}
                                    alt="moveFileIcon"
                                    style={{ width: '40px', height: '40px' }}
                                />
                                <span className={"c15 fw600 ml0-5rem fs20px"}>{"reallocate" === rModalData.actionType ? "Reallocate File" : "Move File"}</span>
                            </> : <>
                                <img
                                    src={require("../../../../images/dataRepo/copy.svg")}
                                    alt="moveFileImg"
                                    style={{ width: '40px', height: '40px' }}
                                />
                                <span className={"c15 fw600 ml0-5rem fs20px"}>Copy File</span>
                            </>
                        }

                    </div>
                    <p className='c3'>{rModalData.fileName}</p>
                </RModal.Header>
                <RModal.Body
                    style={{
                        maxHeight: "550px",
                        paddingRight: "16px"
                    }}
                    className={"lightScrollbar"}
                >
                    <Accordion>
                        {(() => {
                            let module = company?.modules[tab] ?? selectedCompany?.modules[tab];
                            if (module) module = JSON.parse(JSON.stringify(module));
                            return getModuleDropdown(module, rModalData.key, rModalData.from, rModalData.index);
                        })()}
                    </Accordion>
                </RModal.Body>
                <div className={"w100 tac"}>
                    <Button
                        text={rModalData.actionType === "copy" ? "Copy File" : "Move File"}
                        btnType={"warning"}
                        onClick={handleConfirm}
                        customClassName={"mla mra c1"}
                        disabled={selectedQuestion === null || loading}
                    />
                </div>
            </RModal>
        </>
    )
}

export default WarrantyDisclosureTargetList